import React, { useEffect, useState } from 'react'
import {
  AiOutlineClose,
  AiOutlineDown,
  AiOutlineQuestionCircle,
  AiOutlineRight,
} from 'react-icons/ai'
import { BsPlusLg } from 'react-icons/bs'
import { HiMinus } from 'react-icons/hi'
import { Link } from 'gatsby'

const TopItem = ({
  mobileActive,
  index,
  name,
  setDropdown,
  dropdown,
  type,
  uri,
}) => {
  const [active, setActive] = useState(false)

  const Item = () => {
    if (mobileActive && type != 'deals' && type != 'category') {
      return (
        <li
          key={index}
          className='mega-item'
          onClick={() => {
            setDropdown(index)

            if (index === dropdown) {
              setDropdown(false)
            }
          }}
        >
          <span>{name}</span>
          <span className='icon d-lg-none'>
            {dropdown === index ? <HiMinus /> : <BsPlusLg />}
          </span>
        </li>
      )
    } else if (type === 'deals' || type === 'category') {
      return (
        <a href={uri}>
          <li key={index} className='mega-item'>
            <span>{name}</span>
          </li>
        </a>
      )
    } else {
      return (
        <li
          key={index}
          className={`mega-item ${active === dropdown ? 'active' : ''}`}
          onMouseOver={(event) => {
            event.stopPropagation()
            setDropdown(index)

            setActive(index)
          }}
        >
          <span>{name}</span>
          <span
            className={`icon d-none d-lg-block ${
              active === dropdown ? 'active' : ''
            }`}
          >
            <AiOutlineRight />
          </span>
          <span className='icon d-lg-none'>
            {dropdown === index ? <AiOutlineDown /> : <AiOutlineRight />}
          </span>
        </li>
      )
    }
  }

  return <Item />
}

export default TopItem
